import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ChatListDataInterface } from '../../components/chat/ChatListItemsMobile';

export const chatFocusSlice = createSlice({
	name: 'chatFocus',
	initialState: null as ChatListDataInterface | null,
	reducers: {
		setChatInFocus: (_state, action: PayloadAction<ChatListDataInterface | null>) => action.payload,
	},
});
